import { render, staticRenderFns } from "./RoomDeleteConfirm.vue?vue&type=template&id=c07cd9b8"
import script from "./RoomDeleteConfirm.vue?vue&type=script&lang=js"
export * from "./RoomDeleteConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports